import { ComponentProps, useCallback, useContext } from 'react';
import { ButtonWithIcon } from 'src/components/Buttons';
import { useActivePosEntityContext } from 'src/contexts/ActivePosEntityContext';
import { ModalContext } from 'src/contexts/ModalContext';
import { vars } from 'src/core/themes';
import { MarketplaceSale } from 'src/modals/MarketplaceSale/MarketplaceSale';
import { ModalProps } from 'src/modals/Modal';
import { MoneyIcon } from 'src/svgs';
import { ContentId } from 'src/utils/constants/contentId';
import {
  ActionOutboxEntityType,
  ListingDetailDataField,
  ListingDetails,
} from 'src/WebApiController';

export const LaunchCreateMarketplaceSale = ({
  listingId,
  marketplaceListingId,
  cancelTo,
  variant,
  modalSize,
  ...buttonProps
}: Omit<
  ComponentProps<typeof ButtonWithIcon>,
  'onClick' | 'textContentId' | 'icon' | 'iconProps'
> &
  Omit<ComponentProps<typeof MarketplaceSale>, 'event' | 'venue'> & {
    listingId: number;
    marketplaceListingId?: string | null;
    modalSize?: ModalProps['size'];
  }) => {
  const { setModal } = useContext(ModalContext);
  const { setActivePosEntity } = useActivePosEntityContext<ListingDetails>();

  const createOfflineSale = useCallback(() => {
    setModal({
      children: <MarketplaceSale cancelTo={cancelTo} />,
      clickOutsideToClose: true,
      size: modalSize ?? 'slide-in',
      deepLinkValue: listingId,
      trackViewEntityType: ActionOutboxEntityType.Listing,
    });
  }, [setModal, cancelTo, listingId, modalSize]);

  const onLaunchDialog = useCallback(
    (e: React.MouseEvent<HTMLDivElement | HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();

      setActivePosEntity(listingId, marketplaceListingId, true, [
        ListingDetailDataField.Basic,
        ListingDetailDataField.Tickets,
      ]);
      createOfflineSale();
    },
    [createOfflineSale, listingId, marketplaceListingId, setActivePosEntity]
  );

  return (
    <ButtonWithIcon
      {...buttonProps}
      onClick={onLaunchDialog}
      textContentId={ContentId.AddMarketplaceSale}
      icon={<MoneyIcon withHoverEffect size={vars.iconSize.l} />}
      variant={variant}
      textColor={variant === 'textPlain' ? 'strong' : 'brand'}
      style={variant === 'textPlain' ? { width: '100%' } : undefined}
      justifyContent="space-between"
    />
  );
};
